module.exports = __webpack_public_path__ + "static/media/feature-1-giftcard.b421e471.png";